/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CompanyAdminDto } from '../models/CompanyAdminDto';
import type { GetCompanyBranchesAdminResponse } from '../models/GetCompanyBranchesAdminResponse';
import type { GetCompanyPeriodsClientResponse } from '../models/GetCompanyPeriodsClientResponse';
import type { GetCurrentCompanyClientResponse } from '../models/GetCurrentCompanyClientResponse';
import type { Pagination1OfCompanyListedAdminDto } from '../models/Pagination1OfCompanyListedAdminDto';
import type { Pagination1OfCompanySubscriptionListedAdminDto } from '../models/Pagination1OfCompanySubscriptionListedAdminDto';
import type { PostCompanyAdminRequest } from '../models/PostCompanyAdminRequest';
import type { PostPutCompanySubscriptionAdminRequest } from '../models/PostPutCompanySubscriptionAdminRequest';
import type { PutCompanyAdminRequest } from '../models/PutCompanyAdminRequest';
import type { PutCompanyBranchesAdminRequest } from '../models/PutCompanyBranchesAdminRequest';
import type { PutCompanyDisabilityAdminRequest } from '../models/PutCompanyDisabilityAdminRequest';
import type { PutCompanyPeriodsAdminRequest } from '../models/PutCompanyPeriodsAdminRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CompaniesService {
    /**
     * @returns GetCurrentCompanyClientResponse OK
     * @throws ApiError
     */
    public static getCurrentCompanyClient(): CancelablePromise<GetCurrentCompanyClientResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/client/v1/companies/current',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns GetCompanyPeriodsClientResponse OK
     * @throws ApiError
     */
    public static getCurrentCompanyPeriodsClient(): CancelablePromise<GetCompanyPeriodsClientResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/client/v1/companies/current/periods',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewCompanies`
     * @returns CompanyAdminDto OK
     * @throws ApiError
     */
    public static getCompanyAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<CompanyAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/companies/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageCompanies`
     * @returns any OK
     * @throws ApiError
     */
    public static putCompanyAdmin({
        id,
        requestBody,
    }: {
        id: number,
        requestBody?: PutCompanyAdminRequest,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/companies/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageCompanies`
     * @returns any OK
     * @throws ApiError
     */
    public static deleteCompanyAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/admin/v1/companies/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewCompanies`
     * @returns Pagination1OfCompanyListedAdminDto OK
     * @throws ApiError
     */
    public static getCompaniesAdmin({
        id,
        serviceId,
        name,
        userId,
        page,
        limit,
        sortField,
        sortDescending,
    }: {
        id?: number,
        serviceId?: number,
        name?: string,
        userId?: string,
        page?: number,
        limit?: number,
        sortField?: string,
        sortDescending?: boolean,
    }): CancelablePromise<Pagination1OfCompanyListedAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/companies',
            query: {
                'id': id,
                'serviceId': serviceId,
                'name': name,
                'userId': userId,
                'page': page,
                'limit': limit,
                'sortField': sortField,
                'sortDescending': sortDescending,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageCompanies`
     * @returns any OK
     * @throws ApiError
     */
    public static postCompanyAdmin({
        requestBody,
    }: {
        requestBody?: PostCompanyAdminRequest,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/companies',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageCompanies`
     * @returns any OK
     * @throws ApiError
     */
    public static putCompanyPeriodsAdmin({
        id,
        requestBody,
    }: {
        id: number,
        requestBody?: PutCompanyPeriodsAdminRequest,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/companies/{id}/periods',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageCompanies`
     * @returns any OK
     * @throws ApiError
     */
    public static getCompanyPeriodsAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/companies/{id}/periods',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewSubscriptions`
     * @returns Pagination1OfCompanySubscriptionListedAdminDto OK
     * @throws ApiError
     */
    public static getCompanySubscriptionsAdmin({
        id,
        page,
        limit,
        sortField,
        sortDescending,
    }: {
        id: number,
        page?: number,
        limit?: number,
        sortField?: string,
        sortDescending?: boolean,
    }): CancelablePromise<Pagination1OfCompanySubscriptionListedAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/companies/{id}/subscriptions',
            path: {
                'id': id,
            },
            query: {
                'page': page,
                'limit': limit,
                'sortField': sortField,
                'sortDescending': sortDescending,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageSubscriptions`
     * @returns any OK
     * @throws ApiError
     */
    public static postCompanySubscriptionAdmin({
        id,
        requestBody,
    }: {
        id: number,
        requestBody?: PostPutCompanySubscriptionAdminRequest,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/companies/{id}/subscriptions',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageSubscriptions`
     * @returns any OK
     * @throws ApiError
     */
    public static putCompanySubscriptionAdmin({
        id,
        requestBody,
    }: {
        id: number,
        requestBody?: PostPutCompanySubscriptionAdminRequest,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/companies/subscriptions/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewCompanyBranches`
     * @returns GetCompanyBranchesAdminResponse OK
     * @throws ApiError
     */
    public static getCompanyBranchesAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<GetCompanyBranchesAdminResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/companies/{id}/branches',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageCompanyBranches`
     * @returns GetCompanyBranchesAdminResponse OK
     * @throws ApiError
     */
    public static putCompanyBranchesAdmin({
        id,
        requestBody,
    }: {
        id: number,
        requestBody?: PutCompanyBranchesAdminRequest,
    }): CancelablePromise<GetCompanyBranchesAdminResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/companies/{id}/branches',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageCompanies`
     * @returns any OK
     * @throws ApiError
     */
    public static putCompanyDisabilityAdmin({
        id,
        requestBody,
    }: {
        id: number,
        requestBody?: PutCompanyDisabilityAdminRequest,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/companies/{id}/disability',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
